var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "sip-search-overlay" } }, [
    _vm.searchOverlay
      ? _c(
          "div",
          {
            staticClass: "sip-global-search-overlay search-overlay",
            attrs: {
              role: "dialog",
              "aria-modal": "true",
              "aria-label": _vm.trans("general.any_search_title"),
            },
            on: {
              mousedown: function ($event) {
                if ($event.target !== $event.currentTarget) return null
                return _vm.closeSearch.apply(null, arguments)
              },
            },
          },
          [
            _c("div", { staticClass: "sip-global-search-panel" }, [
              _c("div", { staticClass: "sip-global-search-panel__header" }, [
                _c("div", { staticClass: "sip-global-search-input-wrap" }, [
                  _c("em", {
                    staticClass:
                      "icon ni ni-search sip-global-search-input__icon",
                    attrs: { "aria-hidden": "true" },
                  }),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.search,
                        expression: "search",
                      },
                    ],
                    ref: "searchTermElement",
                    staticClass: "sip-global-search-input search-term",
                    attrs: {
                      type: "text",
                      placeholder: _vm.trans("general.any_search_hint"),
                      spellcheck: "false",
                      autocomplete: "off",
                    },
                    domProps: { value: _vm.search },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.search = $event.target.value
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "sip-global-search-close",
                      attrs: {
                        type: "button",
                        "aria-label": _vm.trans("general.close"),
                      },
                      on: { click: _vm.closeSearch },
                    },
                    [
                      _c("em", {
                        staticClass: "icon ni ni-cross",
                        attrs: { "aria-hidden": "true" },
                      }),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "sip-global-search-hint",
                    class: "is-" + _vm.searchHintState,
                  },
                  [
                    _vm.searchHintState === "min-chars"
                      ? [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.trans(
                                  "general.any_search_type_atleast_3_characters"
                                )
                              ) +
                              "\n                    "
                          ),
                        ]
                      : _vm.searchHintState === "loading"
                      ? [
                          _c(
                            "span",
                            { staticClass: "sip-global-search-hint__loading" },
                            [
                              _c("span", {
                                staticClass: "sip-global-search-hint__spinner",
                                attrs: { "aria-hidden": "true" },
                              }),
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.trans("general.any_search_loading")
                                  ) +
                                  "\n                        "
                              ),
                            ]
                          ),
                        ]
                      : _vm.searchHintState === "empty"
                      ? [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.trans("general.no_search_result_found")
                              ) +
                              "\n                    "
                          ),
                        ]
                      : [
                          _c(
                            "span",
                            { staticClass: "sip-global-search-hint__count" },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.searchResultCount) +
                                  "\n                            "
                              ),
                              _c(
                                "span",
                                {
                                  staticClass: "sip-global-search-hint__label",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm
                                        .trans("general.any_search_loaded")
                                        .split(",")[0]
                                    )
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "sip-global-search-hint__kbd" },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.keyboardHint) +
                                  "\n                        "
                              ),
                            ]
                          ),
                        ],
                  ],
                  2
                ),
              ]),
              _vm._v(" "),
              _vm.student_search_results.length ||
              _vm.employee_search_results.length
                ? _c("div", { staticClass: "sip-global-search-panel__body" }, [
                    _c("div", { staticClass: "sip-global-search-columns" }, [
                      _vm.student_search_results.length
                        ? _c(
                            "section",
                            { staticClass: "sip-global-search-section" },
                            [
                              _c(
                                "h3",
                                {
                                  staticClass:
                                    "sip-global-search-section__title",
                                },
                                [_vm._v(_vm._s(_vm.trans("student.student")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "sip-global-search-results" },
                                _vm._l(
                                  _vm.student_search_results,
                                  function (student_record, index) {
                                    return _c(
                                      "article",
                                      {
                                        key: student_record.student.uuid,
                                        staticClass: "sip-search-result-card",
                                        style: {
                                          "--sip-search-stagger": index,
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "sip-search-result-card__inner",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "sip-profile-card__head",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "sip-profile-card__avatar",
                                                  },
                                                  [
                                                    !student_record.student
                                                      .student_photo
                                                      ? [
                                                          student_record.student
                                                            .gender == "female"
                                                            ? _c("img", {
                                                                attrs: {
                                                                  src: _vm.getAbsoluteUrl(
                                                                    "images/avatar_female_kid.png"
                                                                  ),
                                                                  alt: "",
                                                                },
                                                              })
                                                            : _c("img", {
                                                                attrs: {
                                                                  src: _vm.getAbsoluteUrl(
                                                                    "images/avatar_male_kid.png"
                                                                  ),
                                                                  alt: "",
                                                                },
                                                              }),
                                                        ]
                                                      : [
                                                          _c("img", {
                                                            attrs: {
                                                              src: _vm.getImageUrl(
                                                                student_record
                                                                  .student
                                                                  .student_photo
                                                              ),
                                                              alt: "",
                                                            },
                                                          }),
                                                        ],
                                                  ],
                                                  2
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "sip-profile-card__content",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "sip-profile-card__title-row",
                                                      },
                                                      [
                                                        _c(
                                                          "h4",
                                                          {
                                                            staticClass:
                                                              "sip-profile-card__name",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                student_record
                                                                  .student.name
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "sip-profile-card__meta",
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              student_record
                                                                .admission
                                                                .admission_number
                                                            )
                                                          ),
                                                        ]),
                                                        _vm._v(" "),
                                                        student_record.student
                                                          .age
                                                          ? [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "sip-profile-card__meta-sep",
                                                                },
                                                                [_vm._v("·")]
                                                              ),
                                                              _vm._v(" "),
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    student_record
                                                                      .student
                                                                      .age
                                                                      .years +
                                                                      " " +
                                                                      _vm.trans(
                                                                        "list.year"
                                                                      ) +
                                                                      " " +
                                                                      student_record
                                                                        .student
                                                                        .age
                                                                        .months +
                                                                      " " +
                                                                      _vm.trans(
                                                                        "list.month"
                                                                      )
                                                                  )
                                                                ),
                                                              ]),
                                                            ]
                                                          : _vm._e(),
                                                      ],
                                                      2
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "sip-profile-card__detail",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                                " +
                                                            _vm._s(
                                                              student_record
                                                                .batch.course
                                                                .name +
                                                                " " +
                                                                student_record
                                                                  .batch.name
                                                            ) +
                                                            " (" +
                                                            _vm._s(
                                                              student_record.full_roll_number
                                                            ) +
                                                            ")\n                                            "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "sip-profile-card__footer",
                                              },
                                              [
                                                student_record.student.parent
                                                  ? _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          student_record.student
                                                            .parent
                                                            .first_guardian_name
                                                        )
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                student_record.student
                                                  .contact_number
                                                  ? _c("span", [
                                                      _c("em", {
                                                        staticClass:
                                                          "icon ni ni-mobile",
                                                      }),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            student_record
                                                              .student
                                                              .contact_number
                                                          ) +
                                                          "\n                                        "
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "sip-search-result-card__actions",
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn btn-primary btn-sm",
                                                    attrs: { type: "button" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.navigateToStudent(
                                                          student_record.student
                                                            .uuid
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("em", {
                                                      staticClass:
                                                        "icon ni ni-eye-alt",
                                                    }),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.trans(
                                                            "general.view"
                                                          )
                                                        ) +
                                                        "\n                                        "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm.hasPermission(
                                                  "list-student-fee"
                                                )
                                                  ? _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "btn btn-outline-primary btn-sm",
                                                        attrs: {
                                                          type: "button",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.navigateToStudentFee(
                                                              student_record.id,
                                                              student_record
                                                                .student.uuid
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c("em", {
                                                          staticClass:
                                                            "icon ni ni-wallet",
                                                        }),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.trans(
                                                                "finance.view_fee_allocation"
                                                              )
                                                            ) +
                                                            "\n                                        "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.employee_search_results.length
                        ? _c(
                            "section",
                            { staticClass: "sip-global-search-section" },
                            [
                              _c(
                                "h3",
                                {
                                  staticClass:
                                    "sip-global-search-section__title",
                                },
                                [_vm._v(_vm._s(_vm.trans("employee.employee")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "sip-global-search-results" },
                                _vm._l(
                                  _vm.employee_search_results,
                                  function (employee, index) {
                                    return _c(
                                      "article",
                                      {
                                        key: employee.uuid,
                                        staticClass: "sip-search-result-card",
                                        style: {
                                          "--sip-search-stagger": index,
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "sip-search-result-card__inner",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "sip-profile-card__head",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "sip-profile-card__avatar",
                                                  },
                                                  [
                                                    !employee.photo
                                                      ? [
                                                          employee.gender ==
                                                          "female"
                                                            ? _c("img", {
                                                                attrs: {
                                                                  src: _vm.getAbsoluteUrl(
                                                                    "images/avatar_female.png"
                                                                  ),
                                                                  alt: "",
                                                                },
                                                              })
                                                            : _c("img", {
                                                                attrs: {
                                                                  src: _vm.getAbsoluteUrl(
                                                                    "images/avatar_male.png"
                                                                  ),
                                                                  alt: "",
                                                                },
                                                              }),
                                                        ]
                                                      : [
                                                          _c("img", {
                                                            attrs: {
                                                              src: _vm.getImageUrl(
                                                                employee.photo
                                                              ),
                                                              alt: "",
                                                            },
                                                          }),
                                                        ],
                                                  ],
                                                  2
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "sip-profile-card__content",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "sip-profile-card__title-row",
                                                      },
                                                      [
                                                        _c(
                                                          "h4",
                                                          {
                                                            staticClass:
                                                              "sip-profile-card__name",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                employee.name
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("span", {
                                                          staticClass:
                                                            "sip-profile-card__badge",
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              _vm.getStatus(
                                                                employee
                                                              )
                                                            ),
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "sip-profile-card__meta",
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              employee.employee_code
                                                            )
                                                          ),
                                                        ]),
                                                        _vm._v(" "),
                                                        employee.age
                                                          ? [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "sip-profile-card__meta-sep",
                                                                },
                                                                [_vm._v("·")]
                                                              ),
                                                              _vm._v(" "),
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    employee.age
                                                                      .years +
                                                                      " " +
                                                                      _vm.trans(
                                                                        "list.year"
                                                                      ) +
                                                                      " " +
                                                                      employee
                                                                        .age
                                                                        .months +
                                                                      " " +
                                                                      _vm.trans(
                                                                        "list.month"
                                                                      )
                                                                  )
                                                                ),
                                                              ]),
                                                            ]
                                                          : _vm._e(),
                                                      ],
                                                      2
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "sip-profile-card__detail",
                                                      },
                                                      [
                                                        employee
                                                          .employee_designations
                                                          .length &&
                                                        employee
                                                          .employee_designations[0]
                                                          .department_id
                                                          ? [
                                                              _vm._v(
                                                                "\n                                                    " +
                                                                  _vm._s(
                                                                    employee
                                                                      .employee_designations[0]
                                                                      .department
                                                                      .name
                                                                  ) +
                                                                  "\n                                                "
                                                              ),
                                                            ]
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        employee
                                                          .employee_designations
                                                          .length
                                                          ? [
                                                              _vm._v(
                                                                "\n                                                    " +
                                                                  _vm._s(
                                                                    employee
                                                                      .employee_designations[0]
                                                                      .designation
                                                                      .name +
                                                                      " (" +
                                                                      employee
                                                                        .employee_designations[0]
                                                                        .designation
                                                                        .employee_category
                                                                        .name +
                                                                      ")"
                                                                  ) +
                                                                  "\n                                                "
                                                              ),
                                                            ]
                                                          : _vm._e(),
                                                      ],
                                                      2
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "sip-profile-card__footer",
                                              },
                                              [
                                                employee.employee_terms[0]
                                                  ? _c("span", [
                                                      _vm._v(
                                                        "\n                                            " +
                                                          _vm._s(
                                                            _vm.trans(
                                                              "general.since"
                                                            )
                                                          ) +
                                                          " " +
                                                          _vm._s(
                                                            _vm._f("moment")(
                                                              employee
                                                                .employee_terms[0]
                                                                .date_of_joining
                                                            )
                                                          ) +
                                                          "\n                                        "
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                employee.contact_number
                                                  ? _c("span", [
                                                      _c("em", {
                                                        staticClass:
                                                          "icon ni ni-mobile",
                                                      }),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            employee.contact_number
                                                          ) +
                                                          "\n                                        "
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "sip-search-result-card__actions",
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn btn-primary btn-sm",
                                                    attrs: { type: "button" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.navigateToEmployee(
                                                          employee.uuid
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("em", {
                                                      staticClass:
                                                        "icon ni ni-eye-alt",
                                                    }),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.trans(
                                                            "general.view"
                                                          )
                                                        ) +
                                                        "\n                                        "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ])
                : _vm._e(),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }